import { Reveal } from "./Reveal";

const PROFILE_IMG = `${process.env.PUBLIC_URL}/profile-timo.webp`;

export const About = ({ t }) => {
  return (
    <section id="about" className="py-24 md:py-32 lg:py-40" data-testid="about-section">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-start gap-6 mb-10">
            <img
              src={PROFILE_IMG}
              alt="Timo Schewik"
              data-testid="about-image"
              className="w-24 h-28 md:w-28 md:h-32 object-cover object-top shrink-0 ring-1 ring-inset ring-black/5"
            />
            <div>
              <p className="text-xs uppercase tracking-[0.22em] font-bold text-green mb-3">{t.about.eyebrow}</p>
              <h2 className="font-display font-medium text-3xl md:text-4xl text-ink tracking-tight leading-tight">
                {t.about.title}
              </h2>
              <p className="mt-2 text-base md:text-lg text-accent font-medium">{t.about.role}</p>
            </div>
          </div>
        </Reveal>

        <div className="space-y-6">
          {t.about.body.map((p, i) => (
            <Reveal key={i} delay={0.1 + i * 0.08}>
              <p className="text-base md:text-lg text-ink-2 leading-relaxed">{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
